export default __webpack_public_path__ + "static/media/partners21.f9cec1e4.png";